/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceChallengeConfig } from './SurfaceChallengeConfig';
import {
    SurfaceChallengeConfigFromJSON,
    SurfaceChallengeConfigFromJSONTyped,
    SurfaceChallengeConfigToJSON,
    SurfaceChallengeConfigToJSONTyped,
} from './SurfaceChallengeConfig';
import type { SurfaceLeaderboardConfig } from './SurfaceLeaderboardConfig';
import {
    SurfaceLeaderboardConfigFromJSON,
    SurfaceLeaderboardConfigFromJSONTyped,
    SurfaceLeaderboardConfigToJSON,
    SurfaceLeaderboardConfigToJSONTyped,
} from './SurfaceLeaderboardConfig';
import type { SurfaceGameEnabledActivityTypes } from './SurfaceGameEnabledActivityTypes';
import {
    SurfaceGameEnabledActivityTypesFromJSON,
    SurfaceGameEnabledActivityTypesFromJSONTyped,
    SurfaceGameEnabledActivityTypesToJSON,
    SurfaceGameEnabledActivityTypesToJSONTyped,
} from './SurfaceGameEnabledActivityTypes';

/**
 * Hub game configuration - controls which activity types hub owners can use
 * @export
 * @interface SurfaceGameConfig
 */
export interface SurfaceGameConfig {
    /**
     * 
     * @type {SurfaceGameEnabledActivityTypes}
     * @memberof SurfaceGameConfig
     */
    enabledActivityTypes?: SurfaceGameEnabledActivityTypes;
    /**
     * 
     * @type {SurfaceLeaderboardConfig}
     * @memberof SurfaceGameConfig
     */
    leaderboardConfig?: SurfaceLeaderboardConfig;
    /**
     * 
     * @type {SurfaceChallengeConfig}
     * @memberof SurfaceGameConfig
     */
    challengeConfig?: SurfaceChallengeConfig;
    /**
     * ActivityTemplate IDs recommended for this game
     * @type {Array<string>}
     * @memberof SurfaceGameConfig
     */
    linkedTemplateIds?: Array<string>;
}

/**
 * Check if a given object implements the SurfaceGameConfig interface.
 */
export function instanceOfSurfaceGameConfig(value: object): value is SurfaceGameConfig {
    return true;
}

export function SurfaceGameConfigFromJSON(json: any): SurfaceGameConfig {
    return SurfaceGameConfigFromJSONTyped(json, false);
}

export function SurfaceGameConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceGameConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'enabledActivityTypes': json['enabledActivityTypes'] == null ? undefined : SurfaceGameEnabledActivityTypesFromJSON(json['enabledActivityTypes']),
        'leaderboardConfig': json['leaderboardConfig'] == null ? undefined : SurfaceLeaderboardConfigFromJSON(json['leaderboardConfig']),
        'challengeConfig': json['challengeConfig'] == null ? undefined : SurfaceChallengeConfigFromJSON(json['challengeConfig']),
        'linkedTemplateIds': json['linkedTemplateIds'] == null ? undefined : json['linkedTemplateIds'],
    };
}

export function SurfaceGameConfigToJSON(json: any): SurfaceGameConfig {
    return SurfaceGameConfigToJSONTyped(json, false);
}

export function SurfaceGameConfigToJSONTyped(value?: SurfaceGameConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabledActivityTypes': SurfaceGameEnabledActivityTypesToJSON(value['enabledActivityTypes']),
        'leaderboardConfig': SurfaceLeaderboardConfigToJSON(value['leaderboardConfig']),
        'challengeConfig': SurfaceChallengeConfigToJSON(value['challengeConfig']),
        'linkedTemplateIds': value['linkedTemplateIds'],
    };
}

